import { AxiosError } from "axios";

export interface RequestError {
  message: string;
  callOffice: boolean;
}

// `callOffice` when retrying alone is unlikely to help: a server error or no response at all.
// A 5xx message is the raw exception (it can contain SQL), so the mechanic gets a plain one.
export function requestError(e: AxiosError): RequestError {
  if (!e.response) {
    return { message: "Geen verbinding met de server.", callOffice: true };
  }

  if (e.response.status >= 500) {
    return { message: "Er ging iets mis op de server.", callOffice: true };
  }

  return { message: e.response.data?.message ?? e.message, callOffice: false };
}
